/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { MrfiktivAppColorConfigGen, MrfiktivAppColorThemeGen } from "@/services/mrfiktiv/v1/data-contracts";

/**
 * @inheritdoc
 */
export class AppColorConfig implements MrfiktivAppColorConfigGen {
  /** Light color theme */
  light?: MrfiktivAppColorThemeGen;

  /** Dark color theme */
  dark?: MrfiktivAppColorThemeGen;

  constructor(colorTheme?: MrfiktivAppColorConfigGen) {
    if (colorTheme) {
      this.light = colorTheme?.light ? new AppColorTheme(colorTheme.light) : undefined;
      this.dark = colorTheme?.dark ? new AppColorTheme(colorTheme.dark) : undefined;
    }
  }
}

/**
 * Represents a color theme configuration.
 */
export class AppColorTheme implements MrfiktivAppColorThemeGen {
  /** The primary color */
  primary?: string;

  /** The secondary color */
  secondary?: string;

  /** The accent color */
  accent?: string;

  /** The info color */
  info?: string;

  /** The warning color */
  warning?: string;

  /** The success color */
  success?: string;

  /** The error color */
  error?: string;

  /** The analytics colors */
  palette?: string[];

  constructor(theme?: MrfiktivAppColorThemeGen) {
    if (theme) {
      this.primary = theme.primary;
      this.secondary = theme.secondary;
      this.accent = theme.accent;
      this.info = theme.info;
      this.warning = theme.warning;
      this.success = theme.success;
      this.error = theme.error;
      this.palette = theme.palette ? [...theme.palette] : undefined;
    }
  }
}
